<template>
  <v-dialog max-width="1000" v-model="dialog" scrollable persistent :fullscreen="step === 'preview'">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm Điểm môn học {{ $_get(filterParams, 'subject.title') }} theo tệp Excel <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="closePopup">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <StepUpload
          v-if="step === 'upload'"
          ref="step-upload"
          @on-file-change="onFileChanged"
          :isMarkTypeNumber="isMarkTypeNumber"
        />
        <StepPreview v-else-if="step === 'preview'" ref="step-preview" @on-cancel-file="onFileCancelled" />
      </v-card-text>
      <v-divider v-if="step !== 'upload'" />
      <v-card-actions v-if="step === 'preview'">
        <v-btn color="gray" class="ma-2 px-8" :disabled="excelIsCreated" @click="closePopup" outlined>Hủy</v-btn>
        <v-spacer />
        <v-btn color="primary" class="elevation-0 px-8" :loading="excelIsCreated" @click="onSaveMarks">Thêm điểm</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="step === 'result'">
        <v-spacer />
        <v-btn color="primary" class="elevation-0 px-8" @click="closePopup">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import StepUpload from './StepUpload.vue'
import StepPreview from './StepPreview.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { get } from 'lodash'
import unidecode from 'unidecode'
export default {
  components: {
    StepUpload,
    StepPreview
  },
  props: {
    filterParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return { dialog: false, step: 'upload' }
  },
  computed: {
    ...mapState('ClassMarkInput', ['excelIsCreated', 'excelData', 'factors']),
    ...mapGetters('auth', ['profile', 'role']),
    isMarkTypeNumber() {
      return get(this.filterParams, 'subject.markType') === 'mark'
    }
  },
  methods: {
    ...mapActions({
      resetExcelImportState: 'ClassMarkInput/resetExcelImportState',
      saveImportMarks: 'ClassMarkInput/saveImportMarks',
      saveExcelImportPreview: 'ClassMarkInput/saveExcelImportPreview',
      fetchMarks: 'ClassMarkInput/fetchMarks'
    }),
    openPopup() {
      this.dialog = true
    },
    closePopup() {
      const stepUploadCompo = this.$refs['step-upload']
      if (stepUploadCompo) stepUploadCompo.reset()
      this.reset()
      this.dialog = false
      this.resetExcelImportState()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    onFileChanged(errors = []) {
      if (Array.isArray(errors) && errors.length) {
        this.$loading.active = false
        this.$alert.error(`File không đúng định dạng điểm, vui lòng kiểm tra lại dòng ${errors.join(', ')}`)
      } else {
        this.step = 'preview'
        this.$loading.active = false
      }
    },
    onFileCancelled() {
      this.step = 'upload'
    },
    getMarksToSave(marks = []) {
      return marks.map(m => {
        if (this.isMarkTypeNumber) return Number(m)
        const mVal = unidecode(m.toLowerCase())
        return mVal === 'd' ? 1 : 0
      })
    },
    async onSaveMarks() {
      this.$loading.active = true
      const params = { common: this.getCommonParamsToSave() }

      const students = get(this.filterParams, 'class.students', [])
      const factorArr = Object.values(this.factors)
      if (Array.isArray(students) && students.length) {
        const ms = []
        this.excelData.forEach(({ code, marks_1, marks_2, marks_3 }) => {
          const extStudent = students.find(x => x.code === code)
          if (extStudent) {
            const f_marks_1 = marks_1.filter(Boolean),
              f_marks_2 = marks_2.filter(Boolean),
              f_marks_3 = marks_3.filter(Boolean)
            if (f_marks_1.length) {
              const factor = factorArr.find(x => x.multiply === 1)
              ms.push({ student_factor: `${extStudent.id}_${factor.id}`, marks: this.getMarksToSave(f_marks_1) })
            }
            if (f_marks_2.length) {
              const factor = factorArr.find(x => x.multiply === 2)
              ms.push({ student_factor: `${extStudent.id}_${factor.id}`, marks: this.getMarksToSave(f_marks_2) })
            }
            if (f_marks_3.length) {
              const factor = factorArr.find(x => x.multiply === 3)
              ms.push({ student_factor: `${extStudent.id}_${factor.id}`, marks: this.getMarksToSave(f_marks_3) })
            }
          }
        })
        params['ms'] = ms
      }

      try {
        await this.saveImportMarks(params)
        this.$alert.success('Lưu điểm thành công')
        this.saveExcelImportPreview({ excelIsCreated: false })
        await this.fetchMarks(this.filterParams)
        this.closePopup()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    getCommonParamsToSave() {
      const params = {
        class: get(this.filterParams, 'class.id'),
        subject: get(this.filterParams, 'subject.id'),
        grade: get(this.filterParams, 'class.grade.id', null) || get(this.filterParams, 'class.grade'),
        semester: get(this.filterParams, 'semester.id'),
        staff: this.profile.id
      }
      if (this.role.type === 'teacher') params['teacher'] = this.profile.id
      return params
    }
  }
}
</script>
